import { FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import useDeepCompareEffect from 'use-deep-compare-effect';

import EnsureLoggedInContainer from '@/components/EnsureLoggedIn/EnsureLoggedInContainer';
import TimedOrCategorySearchCard from '@/components/GridItemCard/Card/MultiCardOptions/TimedOrCategorySearchCard/TimedOrCategorySearchCard';
import FluidItemGrid from '@/components/GridItemCard/FluidItemGrid/FluidItemGrid';
import PageTitle from '@/components/PageTitle/PageTitle';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { fetchItemSummariesIfNeeded } from '@/redux/modules/item/summary/itemSummary.actions';
import { getLimitedSortedRecentItemIdsFromState } from '@/redux/modules/recentItem';
import { useAppFormatMessage, useAppFormatMessageWithValues } from '@/utils/intl/useAppFormatMessage';

import RecentItemsPageHeaderMeta from './RecentItemsPageHeaderMeta';

const RecentItemsPage = () => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();
    const formatMessageWithValues = useAppFormatMessageWithValues();
    const itemIds = useAppSelector((state) => getLimitedSortedRecentItemIdsFromState(state, 72));

    useDeepCompareEffect(() => {
        dispatch(
            fetchItemSummariesIfNeeded({
                identifier: 'RECENT-ITEMS-PAGE',
                itemIds,
            })
        );
    }, [dispatch, itemIds]);

    return (
        <EnsureLoggedInContainer>
            <div
                className="relative mx-auto min-h-[400px] max-w-[1240px] flex-[1_1] px-sm pb-xl"
                id="recentItems"
            >
                <RecentItemsPageHeaderMeta />
                <div className="mb-lg flex flex-row flex-wrap items-baseline text-[18px] [@media(max-width:416px)]:flex-col [@media(max-width:416px)]:items-center [@media(max-width:416px)]:text-center">
                    <PageTitle title={formatMessage('recently_viewed')} />
                    <span className="ml-xs pr-xs text-[14px] leading-[25px] tracking-[0.5px] text-text-secondary">
                        {formatMessageWithValues('search_item_count_items', {
                            count: (
                                <FormattedNumber
                                    key="recent-items-page-results-count"
                                    style="decimal"
                                    value={itemIds.length}
                                />
                            ),
                        })}
                    </span>
                </div>
                <FluidItemGrid
                    itemCardOption={TimedOrCategorySearchCard}
                    itemIds={itemIds}
                />
            </div>
        </EnsureLoggedInContainer>
    );
};

export default RecentItemsPage;
